import { useUserContext } from '../hooks/UserContext';
import { useQuery } from 'react-query';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import * as UserService from '../services/bioplus-services/user';

const CompanyPicker = ({ value, onChange }) => {
  const userContext = useUserContext();
  const query = useQuery('userRoles', async () => {
    const items = (await UserService.getRoles()) ?? [];

    console.error('ITEMS', items.length);
    return items.map((c) => ({ label: c.companyName, value: c.companyId }));
  });

  if (query.isLoading) {
    return <span>Loading...</span>;
  }
  if (query.isError) {
    return <span>Error...{query.error}</span>;
  }

  const handleChange = (event) => {
    onChange && onChange(event.target.value);
  };

  return (
    <FormControl>
      <InputLabel id="company-filter">Select Entity</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="select-company"
        value={value}
        label="Entity"
        onChange={handleChange}
      >
        {query.data.map((item) => (
          <MenuItem value={item.value}>{item.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CompanyPicker;
